import { Component, inject, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GenesisUnitOfWork } from 'app/core/core.module';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { PartDetailComponent } from '../part-detail/part-detail.component';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-part-lookup-dialog',
    templateUrl: './part-lookup-dialog.component.html',
    styleUrls: ['./part-lookup-dialog.component.scss'],
    standalone: false,
})
export class PartLookupDialogComponent implements OnInit {
    mode: string;
    partId: any;
    items: any[];
    userName: string;
    result: Subject<any> = new Subject<any>();

    onExporting = SharedModule.onExporting;

    modalRef = inject(BsModalRef);
    router = inject(Router);
    uow = inject(GenesisUnitOfWork);
    modalService = inject(BsModalService);

    constructor() {}

    async ngOnInit() {
        const partOptions = await this.uow.getPartByPartOptionsId(this.partId);
        const partLinks = await this.uow.getPartByPartLinkId(this.partId);

        this.items = partOptions.concat(partLinks);
    }
    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }
    async save() {
        // await this.uow.commit();
        this.modalRef.hide();
    }

    cancel() {
        // this.uow.rollback();
        this.modalRef.hide();
    }

    goToDetail(url: string) {
        this.router.navigate([url]);
        this.modalRef.hide();
    }

    goToDetailDialog(url: string) {
        const partId = url.substring(url.lastIndexOf('/') + 1) as any;
        if (isNaN(partId)) return;
        console.log(partId);

        const modalRef = this.modalService.show(PartDetailComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                showAsDialog: true,
                partId: partId,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            modalRef.hide();
        });
    }
}
